import { render, staticRenderFns } from "./CreateVideo.vue?vue&type=template&id=7b705b1a&"
import script from "./CreateVideo.vue?vue&type=script&lang=ts&"
export * from "./CreateVideo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports